import { Outlet } from 'react-router-dom'

export function SettingsLayout() {
    return <Outlet />
}
